import type { LlmAdapter } from "../types.js";

export interface CursorAdapterOptions {
  apiKey?: string;
  model?: string;
}

export class CursorAdapter implements LlmAdapter {
  private apiKey: string;
  private model: string;

  constructor(options: CursorAdapterOptions = {}) {
    this.apiKey = options.apiKey ?? process.env.CURSOR_API_KEY ?? "";
    this.model = options.model ?? "claude-sonnet-4-6";
    if (!this.apiKey) {
      throw new Error(
        "CURSOR_API_KEY environment variable is required for the cursor adapter.",
      );
    }
  }

  async analyze(prompt: string): Promise<string> {
    const { Agent } = (await import("@cursor/sdk")) as {
      Agent: CursorAgentStatic;
    };
    const agentOpts: Record<string, unknown> = {
      model: { id: this.model },
    };
    if (this.apiKey) agentOpts.apiKey = this.apiKey;
    const agent = await Agent.create(agentOpts);
    const run = agent.send(prompt);
    let output = "";
    for await (const event of run.stream()) {
      if (event.type === "assistant" && event.message?.content) {
        output += event.message.content;
      }
    }
    return output;
  }
}

interface CursorAgentStatic {
  create(opts: Record<string, unknown>): Promise<CursorAgentInstance>;
}

interface CursorAgentInstance {
  send(prompt: string): { stream(): AsyncIterable<CursorStreamEvent> };
}

interface CursorStreamEvent {
  type: string;
  message?: { content?: string };
}
